
<div class="flex flex-column w-full">
    <div *ngFor="let version of future_versions" class="flex flex-column">
        <div class="flex flex-row align-items-center justify-content-between">
            <div>
                <span class="font-bold">{{version.otm_date_application |date:'shortDate'}}</span>
            </div>
            <!-- Réduction -->
            <button
                type="button"
                pButton
                icon="p-button-icon-left pi {{ expandedVersions[version.otm_id]? 'pi-arrow-down-left-and-arrow-up-right-to-center' : 'pi-arrow-up-right-and-arrow-down-left-from-center' }}"
                class="p-button-rounded p-button-text"
                (click)="expandedVersions[version.otm_id] = !!!expandedVersions[version.otm_id]"
                [title]="(expandedVersions[version.otm_id]? 'common.collapse': 'common.expand') | translate"
                [label]="(expandedVersions[version.otm_id]? 'common.collapse': 'common.expand') | translate"
            >
            </button>
        </div>

        <div class="html-content article-body w-full" 
            [ngClass]="{expanded: expandedVersions[version.otm_id]}"
            (click)="expandedVersions[version.otm_id] = true"
            [innerHTML]="version.art_corps">
        </div>
    </div>
</div>
